import {PageSettingRevision} from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    pageSettingRevisions: [],
    totalItems: 0,
    errors: null
  },
  mutations: {
    setPageSettingRevision(state, pageSettingRevisions) {
      state.pageSettingRevisions = pageSettingRevisions
    },
    setError(state, error) {
      state.error = error
    },
    settotalItems(state, totalItems) {
      state.totalItems = totalItems
    }
  },
  actions: {
    async fetchByPageSetting({commit}, options) {
      try {
        const {data, total} = await PageSettingRevision.findByPageSetting(options)
        commit('setPageSettingRevision', data)
        commit('settotalItems', total)
        commit('setError', null)
      } catch (error) {
        commit('setError', error)
      }
    },
    async createRevision({commit, dispatch}, data) {
      try {
        await PageSettingRevision.create(data)
        await dispatch('fetchByPageSetting', {
          pageSetting: data.pageSetting._id
        })
        commit('setError', null)
      } catch (error) {
        commit('setError', error)
      }
    },
    async updateRevision({commit, dispatch}, {id, pageSetting, ...data}) {
      try {
        await PageSettingRevision.update(id, data)
        await dispatch('fetchByPageSetting', {
          pageSetting: pageSetting._id
        })
        commit('setError', null)
      } catch (error) {
        commit('setError', error)
      }
    }
  },
  getters: {
    pageSettingRevisions: state => state.pageSettingRevisions,
    totalItems: state => state.totalItems
  }
}
